import { render, staticRenderFns } from "./loanspermember.vue?vue&type=template&id=27b11da2"
import script from "./loanspermember.vue?vue&type=script&lang=js"
export * from "./loanspermember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports